/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1CoachBalance
 */
export interface V1CoachBalance {
    /**
     *
     */
    assetKind: string
    /**
     * Stars inside the refund window
     */
    held: number
    /**
     * Stars paid in the next payout run
     */
    available: number
    /**
     * Stars in payouts not sent yet
     */
    pendingPayout: number
    /**
     *
     */
    paid: number
}

/**
 * Check if a given object implements the V1CoachBalance interface.
 */
export function instanceOfV1CoachBalance(
    value: object
): value is V1CoachBalance {
    if (!('assetKind' in value) || value['assetKind'] === undefined)
        return false
    if (!('held' in value) || value['held'] === undefined) return false
    if (!('available' in value) || value['available'] === undefined)
        return false
    if (!('pendingPayout' in value) || value['pendingPayout'] === undefined)
        return false
    if (!('paid' in value) || value['paid'] === undefined) return false
    return true
}

export function V1CoachBalanceFromJSON(json: any): V1CoachBalance {
    return V1CoachBalanceFromJSONTyped(json, false)
}

export function V1CoachBalanceFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1CoachBalance {
    if (json == null) {
        return json
    }
    return {
        assetKind: json['assetKind'],
        held: json['held'],
        available: json['available'],
        pendingPayout: json['pendingPayout'],
        paid: json['paid']
    }
}

export function V1CoachBalanceToJSON(json: any): V1CoachBalance {
    return V1CoachBalanceToJSONTyped(json, false)
}

export function V1CoachBalanceToJSONTyped(
    value?: V1CoachBalance | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        assetKind: value['assetKind'],
        held: value['held'],
        available: value['available'],
        pendingPayout: value['pendingPayout'],
        paid: value['paid']
    }
}
